var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueSliderArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 30,
    viewBox: "0 0 19 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0209 28.3275L1.40667 16.0359C0.584448 15.2345 0.566755 13.9158 1.3692 13.0925L1.40771 13.0551L14.0209 0.763414C15.0649 -0.254471 16.7311 -0.254471 17.775 0.763414C18.7856 1.74799 18.8065 3.36537 17.8219 4.37493L17.775 4.42176L7.38804 14.5455L17.775 24.6691C18.7856 25.6537 18.8065 27.2711 17.8219 28.2807L17.775 28.3275C16.7311 29.3454 15.0649 29.3454 14.0209 28.3275Z",
    fill: "#115E67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSliderArrowLeft);
export default __webpack_public_path__ + "static/media/blueSliderArrowLeft.b9ae000d8279fea667ac295f29a0166c.svg";
export { ForwardRef as ReactComponent };